import React, { Component } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BlockUi from 'react-block-ui';
import Pagination from "react-js-pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as processOrderAction from './actions'
import { storedb } from '../../views/client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { ButtonExt } from "../controls/ButtonExt"
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { currentDate, formatDateTime, parseDatetime } from "../../lib/common";
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { confirmAlert } from 'react-confirm-alert';

class ProcessOrderChecked extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      dataOrderChecked: {},
      MaHoaDon: '',
      startDate: currentDate().startOf('month'),
      endDate: currentDate(),
      serial: '',
      trangThai: null,
      per_page: 20,
      page: 1,
      total_record: 0,
      isXuatThieu: 0
    };
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleControlChange(name, e) {
    switch (name) {
      case "startDate":
        this.setState({ startDate: e });
        break;
      case "endDate":
        this.setState({ endDate: e });
        break;
      case "TrangThai":
        this.setState({ trangThai: e.target.value });
        break;
      case "MaHoaDon":
        this.setState({ MaHoaDon: e.target.value });
        break;
      case "Serial":
        this.setState({ serial: this.GetQRCodeFromText(e.target.value) });
        break;
    }
  }
  itemXuatThieuChecked = ({ target }) => {
    let { isXuatThieu } = this.state
    isXuatThieu = target.checked ? 1 : 0
    this.setState({ isXuatThieu })
  }
  fetchList = () => {
    const { processOrdersCheckedListRequest } = this.props
    var requestData = {
      maDonXuat: this.state.MaHoaDon,
      startDate: this.state.startDate.unix(),
      endDate: this.state.endDate.endOf('days').unix(),
      qrCode: this.state.serial,
      trangThai: this.state.trangThai,
      isXuatThieu: this.state.isXuatThieu,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return processOrdersCheckedListRequest(requestData, (data) => {
      this.setState({ dataOrderChecked: data })
    });
  }
  search = () => {
    if (this.props.processOrderChecked.requesting) {
      return false;
    }
    return this.fetchList()
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  EditOrderCheckQR = (item, e) => {
    this.props.history.push('/process-order-checkqr/' + (item.Id || ""));
  }
  orderLinkDetails = (soHd) => {
    return `/process-order-detail/${soHd}`
  }
  viewOrder = (e, soHd) => {
    e.preventDefault()
    const url = this.orderLinkDetails(soHd)
    this.props.history.push(url);
  };
  // excel phiếu xuất
  exportXls = () => {
    const dialogSaveFile = (data) => {
      var dataFile = new Blob([data], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "donxuatkho.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("Ten file", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    }
    const requestData = {
      maDonXuat: this.state.MaHoaDon,
      startDate: this.state.startDate.unix(),
      endDate: this.state.endDate.endOf('days').unix(),
      qrCode: this.state.serial,
      trangThai: this.state.trangThai == null ? '' : this.state.trangThai,
      isXuatThieu: this.state.isXuatThieu
    };
    this.props.loadOrderExcel(requestData, dialogSaveFile)
  }
  processRemoveClick = (item) => {
    if (!item.Id && item.Id <= 0) {
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn xoá đơn xuất kho <b className="text-danger">{item.MaXuatKho}</b> không?<br />
              Việc này đồng nghĩa đơn hàng sẽ cập nhật về trạng thái chưa tạo phiếu xuất.
            </p>
            <button className="text-danger" onClick={() => {
              this.props.processOrderDeleteOrder({ xuatKhoId: item.Id }, (data) => {
                this.fetchList()
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  return2List = () => {
    this.props.history.push('/processorders');
  }
  GetQRCodeFromText = (text) => {
    var result = text
    if (text.length > 0) {
      let { dataOrderChecked } = this.state
      if (text.length >= dataOrderChecked.startBarcodePosition) {
        result = text.substr(dataOrderChecked.startBarcodePosition, dataOrderChecked.lengthQRCode)
      }
    }
    console.log("qrcode = " + result)
    return result;
  }

  componentDidMount() {
    this.fetchList();
  }

  render() {
    const {
      handleSubmit,
      processOrderChecked: {
        requesting,
        errors,
        messages
      },
    } = this.props
    const { dataOrderChecked } = this.state
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="startDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Từ ngày"
                      selected={this.state.startDate}
                      onChange={this.handleControlChange.bind(
                        this,
                        "startDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1  pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="endDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Đến ngày"
                      selected={this.state.endDate}
                      popperClassName="react-end-date"
                      popperPlacement="top-end"
                      onChange={this.handleControlChange.bind(
                        this,
                        "endDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="3" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off">
                      Từ khóa
                    </InputGroupAddon>
                    <Input
                      name="MaHoaDon"
                      placeholder="Mã hóa đơn, ghi chú"
                      value={this.state.MaHoaDon}
                      onChange={this.handleControlChange.bind(
                        this,
                        "MaHoaDon"
                      )}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off">
                      Serial
                    </InputGroupAddon>
                    <Input
                      name="Serial"
                      placeholder="Mã Serial"
                      value={this.state.serial}
                      onChange={this.handleControlChange.bind(
                        this,
                        "Serial"
                      )}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <select
                      className="form-control"
                      value={this.state.trangThai || ''}
                      onChange={this.handleControlChange.bind(this, "TrangThai")}
                    >
                      <option value="">Trạng thái</option>
                      <option value={1}>Chưa xác nhận</option>
                      <option value={2}>Đã xác nhận</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="1" className="mb-1 pl-2 pr-2">
                  <label className="p-2 text-danger"><input type="checkbox" onChange={e => this.itemXuatThieuChecked(e)} /> Xuất thiếu</label>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="pull-left mr-1"
                onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
              <Button size="md" color="primary" className="mr-1" onClick={() => this.return2List()}>
                <i className="fa fa-list"></i> Tạo phiếu xuất</Button>
              <Button size="md" color="primary" className="mr-1"
                onClick={handleSubmit(this.exportXls)}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
              <div className="clearfix"></div>
            </div>
            <div className="w-100">
              <Row>
                <Col md="12">
                  {!requesting && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!requesting && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </Col>
              </Row>
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="50" className="text-center">#</th>
                    <th scope="col" width="120" className="text-left">Mã xuất kho</th>
                    <th scope="col" width="150" className="text-left">Ngày tạo</th>
                    <th scope="col" width="170" className="text-left">Nhân viên</th>
                    <th scope="col" width="150" className="text-left">Trạng thái</th>
                    <th scope="col" width="100" className="text-center">Xuất đủ hàng</th>
                    <th scope="col" width="150" className="text-left">Ngày xuất</th>
                    <th scope="col" className="text-left">Ghi chú</th>
                    <th scope="col" width="100" className="text-center">Xuất đơn</th>
                    <th scope="col" width="30" className="text-center">Xóa</th>
                  </tr>
                </thead>
                <tbody>
                  {dataOrderChecked.records && !!dataOrderChecked.records.length && (
                    dataOrderChecked.records.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{idx + 1}</td>
                        <td className="text-left"><a href={`/#${this.orderLinkDetails(res.Id)}`} onClick={(e) => this.viewOrder(e, res.Id)}>{res.MaXuatKho}</a></td>
                        <td className="text-left">{formatDateTime(res.NgayTao, "HH:mm DD/MM/YYYY")}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        <td className="text-left">
                          {res.TrangThai == 1 && <span className="text-danger">{res.TenTrangThai}</span>}
                          {res.TrangThai == 2 && <span className="text-success">{res.TenTrangThai}</span>}
                        </td>
                        <td className="text-center">{<i className={res.XuatThieu ? "fa fa-times text-danger" : "fa fa-check text-success"}></i>}</td>
                        <td className="text-left">{formatDateTime(res.NgayXuat, "HH:mm DD/MM/YYYY")}</td>
                        <td className="text-left">{res.GhiChuXuatThieu}</td>
                        <td scope="row" className="text-center">
                          <ButtonExt
                            btnClass="text-primary"
                            iconClass="fa-paper-plane fa-lg"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.EditOrderCheckQR(res)}
                            permission={BtnPermissions.DonXuatKho.CREATE_PROCESS_ORDER} />
                        </td>
                        <td scope="row" className="text-center">
                          {
                            res.TrangThai != 2 ? <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-trash fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.processRemoveClick(res)}
                              permission={BtnPermissions.DonXuatKho.DELETE_ORDER} />
                              : ''
                          }
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {dataOrderChecked.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={dataOrderChecked.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  processOrderChecked: state.processOrderChecked,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  processOrdersCheckedListRequest: processOrderAction.processOrdersCheckedListRequest,
  processOrderDeleteOrder: processOrderAction.processOrderDeleteOrder,
  loadOrderExcel: processOrderAction.loadOrderExcel
})(ProcessOrderChecked)
const formed = reduxForm({
  form: 'processOrderChecked',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/ProcessOrders/ProcessOrderChecked.js